import React from "react";
import { ArrowLeft } from "lucide-react";

// "Voltar" padrão das telas internas — a seta saiu do Header global (decisão
// do dono: barra idêntica em toda tela), então cada tela mostra o seu voltar.
// nav('back') usa o histórico real do navegador com fallback pra home (App.js),
// então funciona também em deep-link e no desktop (sem gesto de swipe).
export const VoltarBar = ({ nav, label = "Voltar" }) => (
  <button
    onClick={() => nav('back')}
    className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-slate-500 hover:text-[#12192a] transition-colors mb-3"
  >
    <ArrowLeft size={16} strokeWidth={2.2} /> {label}
  </button>
);
